import React, { useState, useEffect, useContext } from 'react';
import ICourseStatusReport from '../../model/ICourseStatusReport'
import { Grid, GridColumn, GridSortChangeEvent } from '@progress/kendo-react-grid'
import ReportsService from '../../services/ReportsService'
import { Year } from '../../services/AppContext'
import { CompositeFilterDescriptor, filterBy, orderBy, SortDescriptor } from "@progress/kendo-data-query";
import { ExcelExport } from '@progress/kendo-react-excel-export';

interface ILocation {
    changeExcelRef: any;
    selectedReport: any
}

const initialDataState = {
    skip: 0,
    take: 10,
};

const initialFilter: CompositeFilterDescriptor = {
    logic: "and",
    filters: [],
};

const initialSort: Array<SortDescriptor> = [
    { field: "totalCourses", dir: "desc" },
];

export default function CourseStatusReport(props: ILocation) {
    const { orginalSchoolYear } = useContext(Year);
    const [filter, setFilter] = React.useState(initialFilter);
    const [page, setPage] = React.useState(initialDataState);
    const [sort, setSort] = React.useState(initialSort);
    const [rowData, setRowData] = useState<ICourseStatusReport[]>([]);
    const _export = React.useRef<ExcelExport | null>(null);
    const pageChange = (event: any) => {
        setPage(event.page);
    };

    const GetCourseStatusReport = () => {
        ReportsService.GetStatusWiseReport(+orginalSchoolYear.id).then(response => {
            setRowData(response.data)
            props.changeExcelRef(_export)
        })
    }
    useEffect(() => {
        GetCourseStatusReport();
    }, [props.selectedReport, orginalSchoolYear.id]);

    const filterReportData = (data: any, filter: any) => {
        let report = rowData;
        return filterBy(report, filter);
      }
      const onFilterChange = (e: any) => {
        setPage(initialDataState)
        setFilter(e.filter)
      }


    return (
        <ExcelExport data={rowData} ref={_export} fileName={"Courses_Status_Report" + ' ' + new Date().toDateString()}>
            <Grid
                data={filterReportData(orderBy(rowData, sort),filter).slice(page.skip, page.take + page.skip)}
                skip={page.skip}
                take={page.take}
                total={rowData.length}
                pageSize={page.take}
                pageable={{ pageSizes: [10, 25, 50], info: true }}
                onPageChange={pageChange}
                sortable={true}
                sort={sort}
                onSortChange={(e: GridSortChangeEvent) => {
                    setSort(e.sort);
                }}
                filterable={true}
                filter={filter}
                onFilterChange={onFilterChange}
                style={{width:"auto"}}
                scrollable={"scrollable"}>
                <GridColumn field="locationCode" width="180px" filterable={true} title="School"></GridColumn>
                <GridColumn field="totalCourses" filterable={false} title="Total Courses"></GridColumn>
                <GridColumn field="newCourses" filterable={false}  title="New"></GridColumn>
                <GridColumn field="publishedCourses" filterable={false}  title="Published"></GridColumn>
                <GridColumn field="editedCourses" filterable={false}  title="Edited" ></GridColumn>
                <GridColumn field="closedCourses" filterable={false}  title="Closed"></GridColumn>
                <GridColumn field="starsCourses" filterable={false}  title="Stars"></GridColumn>
                <GridColumn field="manualCourses" filterable={false}  title="Manual"></GridColumn>
                <GridColumn field="sharedCourses" filterable={false}  title="Shared"></GridColumn>
                <GridColumn field="totalStudents" filterable={false}  title="Students" ></GridColumn>
                <GridColumn field="totalTeachers" filterable={false}  title="Teachers"></GridColumn>
            </Grid>
        </ExcelExport>
    )
}